import { render } from "./MissedCallsChart.vue?vue&type=template&id=701a9d34&ts=true"
import script from "./MissedCallsChart.vue?vue&type=script&lang=ts"
export * from "./MissedCallsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__